import { Organization } from '@enview/interface/types/Organization';
import { track, page } from './AmplitudeAnalytics';

enum AnalyticsEvent {
  ORG_USER_REMOVED = 'Removed user from an organization',
  ORG_USER_SUSPENDED = 'Suspended user from an organization',
  ORG_USER_ROLE_UPDATED = "Changed an organization user's permissions",
  VIEWED_ORG_PAGE = 'Viewed Org Settings Page',
  CUSTOM_FIELD_CREATED = 'Created Organization Custom Field',
  CUSTOM_FIELD_UPDATED = 'Updated Organization Custom Field',
  CUSTOM_FIELD_DELETED = 'Deleted Organization Custom Field',
}

export const trackOrgUserRemoved = (targetUserId: number, orgId: number): void => {
  track(AnalyticsEvent.ORG_USER_REMOVED, {
    targetUserId,
    orgId,
  });
};

export const trackOrgUserSuspended = (
  targetUserId: number,
  orgId: number,
  isSuspended: boolean,
): void => {
  track(AnalyticsEvent.ORG_USER_SUSPENDED, {
    targetUserId,
    orgId,
    isSuspended,
  });
};

export const trackOrgUserRoleUpdated = (
  targetUserId: number,
  orgId: number,
  orgRole: string,
): void => {
  track(AnalyticsEvent.ORG_USER_ROLE_UPDATED, {
    targetUserId,
    orgId,
    orgRole,
  });
};

export const trackViewedOrgPage = (org: Organization): void => {
  page('Org Settings', AnalyticsEvent.VIEWED_ORG_PAGE, {
    orgName: org.name,
  });
};

export const trackCustomFieldCreated = (orgId: number, customField: string): void => {
  track(AnalyticsEvent.CUSTOM_FIELD_CREATED, {
    orgId,
    customField,
  });
};

export const trackCustomFieldUpdated = (orgId: number, customField: string): void => {
  track(AnalyticsEvent.CUSTOM_FIELD_UPDATED, {
    orgId,
    customField,
  });
};

export const trackCustomFieldDeleted = (orgId: number, customField: string): void => {
  track(AnalyticsEvent.CUSTOM_FIELD_DELETED, {
    orgId,
    customField,
  });
};
